// AED Status Types (Expired B/P = one case for battery or pads expired)
export const AED_STATUSES = {
  READY: 'READY',
  NOT_READY: 'NOT_READY',
  REPOSITION: 'REPOSITION',
  AED_NOT_PRESENT: 'AED_NOT_PRESENT',
  BATTERY_EXPIRED: 'BATTERY_EXPIRED',
  EXPIRING_BATT_PADS: 'EXPIRING_BATT_PADS',
  CAMERA_ISSUE: 'CAMERA_ISSUE',
  UNKNOWN: 'UNKNOWN',
  LOST_CONTACT: 'LOST_CONTACT'
};

// Explicit order for filter dropdown and status overview
export const AED_STATUS_ORDER = [
  'READY',
  'NOT_READY',
  'REPOSITION',
  'AED_NOT_PRESENT',
  'BATTERY_EXPIRED',
  'EXPIRING_BATT_PADS',
  'CAMERA_ISSUE',
  'UNKNOWN',
  'LOST_CONTACT'
];

// Status display config
export const STATUS_CONFIG = {
  READY: {
    label: 'Ready',
    color: 'text-emerald-400',
    bgColor: 'bg-emerald-500/15 border-emerald-500/50',
    dotColor: 'bg-emerald-500',
    icon: 'CheckCircle'
  },
  REPOSITION: {
    label: 'Reposition',
    color: 'text-amber-400',
    bgColor: 'bg-amber-500/15 border-amber-500/50',
    dotColor: 'bg-amber-500',
    icon: 'AlertTriangle'
  },
  AED_NOT_PRESENT: {
    label: 'Not Present',
    color: 'text-red-400',
    bgColor: 'bg-red-500/15 border-red-500/50',
    dotColor: 'bg-red-500',
    icon: 'XCircle'
  },
  BATTERY_EXPIRED: {
    label: 'Expired B/P',
    color: 'text-red-400',
    bgColor: 'bg-red-500/15 border-red-500/50',
    dotColor: 'bg-red-500',
    icon: 'BatteryWarning'
  },
  EXPIRING_BATT_PADS: {
    label: 'Expiring B/P',
    color: 'text-amber-400',
    bgColor: 'bg-amber-500/15 border-amber-500/50',
    dotColor: 'bg-amber-500',
    icon: 'Timer'
  },
  NOT_READY: {
    label: 'Not Ready',
    color: 'text-red-400',
    bgColor: 'bg-red-500/15 border-red-500/50',
    dotColor: 'bg-red-500',
    icon: 'AlertTriangle'
  },
  CAMERA_ISSUE: {
    label: 'Camera Issue',
    color: 'text-orange-400',
    bgColor: 'bg-orange-500/15 border-orange-500/50',
    dotColor: 'bg-orange-500',
    icon: 'Camera'
  },
  UNKNOWN: {
    label: 'Unknown',
    color: 'text-slate-400',
    bgColor: 'bg-slate-500/15 border-slate-500/50',
    dotColor: 'bg-slate-500',
    icon: 'HelpCircle'
  },
  LOST_CONTACT: {
    label: 'LOST CONTACT',
    color: 'text-slate-500',
    bgColor: 'bg-slate-600/15 border-slate-600/50',
    dotColor: 'bg-slate-600',
    icon: 'WifiOff'
  }
};

// Get status config helper
export const getStatusConfig = (status) => {
  return STATUS_CONFIG[status] || STATUS_CONFIG.UNKNOWN;
};

// Format confidence as percentage
export const formatConfidence = (confidence) => {
  return `${Math.round(confidence * 100)}%`;
};

// Format timestamp
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Generate random ID
export const generateId = () => {
  return Math.random().toString(36).substr(2, 9);
};
